import {useMutation} from '@tanstack/react-query'
import {sendGroupMessage} from '../services/chat.http'
import {MUTATION_KEYS} from './keys'
import {CreateGroupPayload} from '../chat.model'
import {UserRoleE} from '@/types'
import {useMe} from '@/features/authentication/queries/useMe'
import {LocalStorageManager} from '@/utilities/localStorage'

export const useSendGroupMessageV3 = () => {
    const {data: user} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const representedCreatorId = isRepresentative ? LocalStorageManager.chatUserId.get() : undefined

    return useMutation({
        mutationKey: [MUTATION_KEYS.sendGroupMessageV3],
        mutationFn: (params: {groupId: string; payload: CreateGroupPayload}) =>
            sendGroupMessage({...params, representedCreatorId})
    })
}
